<template>
  <div class="board-container">
    <!-- 功能 -->
    <div class="header-menu">
      <el-input placeholder="搜索讲师" v-model="keyword" @clear="inputListener" clearable>
        <el-button slot="append" type="primary" icon="el-icon-search" @click="searchTeacher">搜索</el-button>
      </el-input>
      <el-button type="primary" @click="addTeacher()" class="addbtn btns" size="small" icon="el-icon-plus">添加讲师</el-button>
      <el-button type="primary" @click="addBtn()" class="addbtn btns" size="small" icon="el-icon-download">导出</el-button>
    </div>
    <!-- 讲师列表 -->
    <el-table :header-cell-style="{
      background: '#fafafa'
    }" height="700" style="margin-top: 20px;width: 100%;" :data="teacherData"  :highlight-current-row="true">
      <el-table-column label="序号" type="selection"></el-table-column>
      <el-table-column prop="realname" label="姓名">
        <template slot-scope="scope">
          <router-link :to="'/teacher-detail/' + scope.row.id" class="name-link" @click="highlightRow(scope.$index)">
            {{ scope.row.realname }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="telephone" label="联系电话" width="100"></el-table-column>
      <el-table-column prop="email" label="邮箱" width="150"></el-table-column>
      <el-table-column prop="age" label="年龄" width="50"></el-table-column>
      <el-table-column prop="cardId" label="身份证号" width="150"></el-table-column>
      <el-table-column prop="teachName" label="学科"></el-table-column>
      <el-table-column prop="jobName" label="职级"></el-table-column>
      <el-table-column prop="jobStatus" label="在职状态">
        <template slot-scope="scope">
          <span v-if="scope.row.jobStatus === 1">在职</span>
          <span v-else-if="scope.row.jobStatus === 2">离职</span>
        </template>
      </el-table-column>
      <el-table-column prop="education" label="学历" width="50"></el-table-column>
      <el-table-column prop="graduationSchool" label="毕业院校" width="100"></el-table-column>
      <el-table-column prop="entryTime" label="入职时间" width="90"></el-table-column>
      <el-table-column prop="recruitmentChannel" label="招聘渠道"></el-table-column>
      <el-table-column prop="bossName" label="Boss直聘来源负责人"></el-table-column>
      <el-table-column prop="introducerName" label="内推人"></el-table-column>
      <el-table-column prop="address" label="地址" width="160"></el-table-column>
      <el-table-column prop="monStatus" label="周一上课意愿" width="130">
        <template slot-scope="scope">
          {{ scope.row.monStatus == 1 ? '接受排课' : '不接受排课' }}
        </template>
      </el-table-column>
      <el-table-column prop="satNum" label="周六课节数不超过" width="130">
        <template slot-scope="scope">
          {{ scope.row.satNum == 1 ? "服从安排" : scope.row.satNum == 2 ? "不排课" : scope.row.satNum == 3 ? "排一节" :
            scope.row.satNum == 4 ? "排二节" : scope.row.satNum == 5 ? "排三节" : scope.row.satNum == 6 ? "排四节" : scope.row.satNum
              == 7 ? "排五节" : scope.row.satNum == 8 ? "排六节" : "" }}
        </template>

      </el-table-column>
      <el-table-column prop="sunNum" label="周日课节数不超过" width="130">
        <template slot-scope="scope">
          {{ scope.row.sunNum == 1 ? "服从安排" : scope.row.sunNum == 2 ? "不排课" : scope.row.sunNum == 3 ? "排一节" :
            scope.row.sunNum == 4 ? "排二节" : scope.row.sunNum == 5 ? "排三节" : scope.row.sunNum == 6 ? "排四节" : scope.row.sunNum
              == 7 ? "排五节" : scope.row.sunNum == 8 ? "排六节" : "" }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="email"
        label="邮箱"
        fixed
        width="200"
      ></el-table-column> -->
      <el-table-column label="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="editById(scope.$index, scope.row)">编辑</el-button>
          <!-- <el-button size="mini" type="text" @click="deleteById(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹出表单编辑讲师 :rules="addTeacherRules"-->
    <el-dialog id="ff" title="编辑讲师" :visible.sync="visibleForm" :close-on-click-modal = false>
      <el-form :model="editFormData" ref="editFormData" label-position="right" label-width="130px">
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="editFormData.realname" autocomplete="off"  placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input v-model="editFormData.age" autocomplete="off"  placeholder="请输入年龄"></el-input>
        </el-form-item>
        <el-form-item label="职级" prop="jobName">
          <el-select style="width: 100%" filterable   v-model="editFormData.jobName" autocomplete="off" placeholder="请选择职级" clearable>
            <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
              :value="jobStatu.jobId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="薪资方案">
          <el-select style="width: 100%" filterable   v-model="editFormData.salaryPlanId" placeholder="请选择" clearable>
            <el-option v-for="item in planlist" :key="item.id" :label="item.planName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在职状态" prop="jobStatus">
          <el-select style="width: 100%" filterable   v-model="editFormData.jobStatus" autocomplete="off" placeholder="请选择在职状态"
            clearable>
            <el-option v-for="item in names" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科" prop="teach">
          <!-- <el-input v-model="editFormData.teach" autocomplete="off" placeholder="请输入学科"></el-input> -->
          <el-select  placeholder="请选择学科"  v-model="editFormData.teach" multiple  style="width: 100%"  clearable  filterable>
             <el-option  v-for="item in subjectArr_s"  :key="item.id"   :value="item.id"   :label="item.categoryName"> </el-option>
           </el-select>
        </el-form-item>
        <el-form-item label="电话 " prop="telephone">
          <el-input v-model="editFormData.telephone" placeholder="请输入电话" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input  v-model="editFormData.email" placeholder="请输入邮箱" ></el-input>
        </el-form-item>
        <el-form-item label="入职时间" prop="entryTime">
          <el-date-picker style="width: 100%;" v-model="editFormData.entryTime" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-input v-model="editFormData.education" placeholder="请输入学历" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="毕业院校" prop="graduationSchool">
          <el-input placeholder="请输入毕业院校" v-model="editFormData.graduationSchool" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="cardId">
          <el-input v-model="editFormData.cardId" autocomplete="off" placeholder="请输入身份证号" maxlength="18"></el-input>
        </el-form-item>


        <el-form-item label="周一上课意愿">
          <el-select style="width:100%;" filterable   v-model="editFormData.monStatus" clearable>
            <el-option v-for="item in workSchedule" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周六课节数不超过">
          <el-select v-model="editFormData.satNum"  filterable  style="width:100%;" clearable>
            <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周日课节数不超过">
          <el-select v-model="editFormData.sunNum" filterable   style="width:100%;" clearable>
            <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="家庭地址" prop="address">
          <el-input v-model="editFormData.address" placeholder="请输入家庭住址" autocomplete="off"></el-input>
        </el-form-item>



        <el-form-item label="招聘渠道" style="text-align: left;">
          <el-radio v-model="editFormData.radio1" label="1">BOSS直聘</el-radio>
          <el-radio v-model="editFormData.radio1" label="2">内推</el-radio>
        </el-form-item>
        <el-form-item label="Boss直聘来源负责人" v-if="editFormData.radio1 == '1'" style="text-align: left;" label-width="150px">
          <el-input v-model="editFormData.bossName" autocomplete="off" placeholder="请输入Boss直聘来源负责人"></el-input>
        </el-form-item>
        <el-form-item label="内推人" v-if="editFormData.radio1 == '2'">
          <el-input v-model="editFormData.name" autocomplete="off" placeholder="请输入内推人姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item label="邮件">
          <el-input v-model="editFormData.email" autocomplete="off"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleForm = false">取 消</el-button>
        <el-button type="primary" @click="commit()">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 弹出表单添加讲师  :rules="addTeacherRules"-->
    <el-dialog id="bb" title="添加讲师" :visible.sync="visibleAddForm">
      <el-form :model="addTeacherForm" label-position="right" label-width="130px" ref="addTeacherForm">
        <el-form-item label="姓名">
          <el-input placeholder="请输入姓名" v-model="addTeacherForm.realname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="addTeacherForm.age" autocomplete="off" placeholder="请输入年龄"></el-input>
        </el-form-item>
        <el-form-item label="职级">
          <el-select style="width: 100%" filterable   v-model="addTeacherForm.jobName" autocomplete="off" placeholder="请选择职级"
            clearable>
            <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
              :value="jobStatu.jobId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="薪资方案">
          <el-select style="width: 100%" filterable  v-model="addTeacherForm.salaryPlanId" placeholder="请选择" clearable>
            <el-option v-for="item in planlist" :key="item.id" :label="item.planName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在职状态">
          <el-select style="width: 100%" filterable   v-model="addTeacherForm.jobStatus" autocomplete="off" placeholder="请选择在职状态"
            clearable>
            <el-option v-for="item in names" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科">
          <!-- <el-input v-model="addTeacherForm.teach" autocomplete="off" placeholder="请输入学科"></el-input> -->
           <el-select  placeholder="请选择学科"  v-model="addTeacherForm.teach" multiple  style="width: 100%"  clearable  filterable>
             <el-option  v-for="item in subjectArr_s"  :key="item.id"   :value="item.id"   :label="item.categoryName"> </el-option>
           </el-select>
        </el-form-item>
        <el-form-item label="电话">
          <el-input maxlength="11" v-model="addTeacherForm.telephone" placeholder="请输入电话" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input  v-model="addTeacherForm.email" placeholder="请输入邮箱" ></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-input v-model="addTeacherForm.education" placeholder="请输入学历" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="毕业院校" prop="graduationSchool">
          <el-input v-model="addTeacherForm.graduationSchool" placeholder="请输入毕业院校" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="cardId">
          <el-input v-model="addTeacherForm.cardId" autocomplete="off" placeholder="请输入身份证号" maxlength="18"></el-input>
        </el-form-item>

        <el-form-item label="周一上课意愿">
          <el-select style="width:100%;" filterable   v-model="addTeacherForm.monStatus" clearable>
            <el-option v-for="item in workSchedule" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周六课节数不超过">
          <el-select v-model="addTeacherForm.satNum"  filterable  style="width:100%;" clearable>
            <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周日课节数不超过">
          <el-select v-model="addTeacherForm.sunNum"  filterable  style="width:100%;" clearable>
            <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="家庭地址" prop="address">
          <el-input v-model="addTeacherForm.address" placeholder="请输入家庭住址" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="入职时间">
          <el-date-picker style="width: 100%" v-model="addTeacherForm.entryTime" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="招聘渠道" style="text-align: left;">
          <el-radio v-model="addTeacherForm.radio" label="1">BOSS直聘</el-radio>
          <el-radio v-model="addTeacherForm.radio" label="2">内推</el-radio>
        </el-form-item>
        <el-form-item label="Boss直聘来源负责人" v-if="addTeacherForm.radio == '1'" label-width="150px"
          style="text-align: left;">
          <el-input v-model="addTeacherForm.bossName" autocomplete="off" placeholder="请输入Boss直聘来源负责人"></el-input>
        </el-form-item>
        <el-form-item label="内推人" v-if="addTeacherForm.radio == '2'">
          <el-input v-model="name1" autocomplete="off" placeholder="请输入内推人姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="addTeacherForm.email"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleAddForm = false">取 消</el-button>
        <el-button type="primary" @click="addCommit()">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 上一页，当前页，下一页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="jobParameters.currentpage" :page-size="jobParameters.pagesize"
      layout="prev, pager, next,sizes,jumper" :total="total"></el-pagination>

      <el-dialog title="导出设置" :visible.sync="addBtnShow">

        <div style="display: flex;">
          <div style="padding-top: 10px;">时间范围：</div>
          <div> 
            <el-date-picker
              v-model="rangeTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
           </div>
        </div>

        <div style="display: flex;margin-top: 20px;">
          <div style="padding-top: 10px;">导出类型：</div>
          <div> 
            <el-select v-model="rangevalue" placeholder="请选择">
              <el-option
                v-for="item in rangeoptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addCommitBtn">开始导出</el-button>
        </div>

      </el-dialog>


  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import loadingUtils from "../../utils/loading";
import { getSubject,} from "@/api/firstClassApi";
export default {
  name: "TeacherList",
  data () {
    return {

      rangevalue:'',
      rangeTime:[],
      rangeoptions:[{id:1,name:'跟进学员'}],
      graduationSchool: "", //毕业学校
      education: "", //学历
      cardId: "", //身份证号
      name: "",
      name1: "",
      radio: "1",
      teacherData: [],
      entryTime: "",
      keyword: "",
      page: 1,
      introducerName: "",
      recruitmentChannel: "",
      pageSize: 10,
      total: 0,
      visibleForm: false,
      visibleAddForm: false,
      jobParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1 //当前页码
      },
      editFormData: {
        salaryPlanId: "",
        bossName: "",
        graduationSchool: "", //毕业学校
        education: "", //学历
        cardId: "", //身份证号
        recruitmentChannel: "",
        realname: "",
        jobtitle: "",
        email: "",
        teach: "",
        radio1: "1",
        introducerName: "",
        telephone: "",
        age: "",
        name: "",
        jobStatus: "",
        jobName: "",
        id: "",
        entryTime: "",
        monStatus: "",
        satNum: "",
        sunNum: "",
        address: "",
      },
      names: [
        {
          value: 1,
          label: "在职"
        },
        {
          value: 2,
          label: "离职"
        }
      ],

      jobStatus: null,
      jobs: [], //职级下拉框默认值
      // addTeacherRules: {
      //   realname: [
      //     { required: true, message: "请输入真实姓名", trigger: "blur" }
      //   ],
      //   // jobtitle: [{ required: true, message: "请输入职称", trigger: "change" }],
      //   teach: [{ required: true, message: "请输入科目", trigger: "blur" }],
      //   telephone: [
      //     { required: true, message: "请输入手机号码", trigger: "blur" }
      //   ],
      //   email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      //   age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
      //   jobStatus: [
      //     { required: true, message: "请输入在职状态", trigger: "change" }
      //   ],
      //   jobName: [{ required: true, message: "请输入职级", trigger: "change" }]
      // },
      addBtnShow:false,
      addTeacherForm: {
        salaryPlanId: '',
        bossName: "",
        graduationSchool: "", //毕业学校
        education: "", //学历
        cardId: "", //身份证号
        realname: "",
        jobtitle: "",
        teach: "",
        telephone: "",
        introducerName: "",
        recruitmentChannel: "",
        // address: "",
        email:"",
        radio: "1",
        age: "",
        jobStatus: "",
        jobName: "",
        entryTime: "",
        monStatus: 1,
        satNum: 1,
        sunNum: 1,
        address: "",
      },
      workSchedule: [
        {
          value: "接受排课",
          id: 1,
        },
        {
          value: "不接受排课",
          id: 2,
        }
      ],
      workWeekend: [
        {
          value: "服从安排",
          id: 1,
        },
        {
          value: "不排课",
          id: 2,
        },
        {
          value: "排一节",
          id: 3,
        },
        {
          value: "排二节",
          id: 4,
        },
        {
          value: "排三节",
          id: 5,
        },
        {
          value: "排四节",
          id: 6,
        },
        {
          value: "排五节",
          id: 7,
        },
        {
          value: "排六节",
          id: 8,
        }
      ],
      planlist: [],
      subjectArr_s:[],
    };
  },
  mounted () {
    this.allTeacher();
    this.fetchJob();
    this.getPlan()
    getSubject().then((res) => { this.subjectArr_s = res.data; })
  },

  methods: {
    addCommitBtn(){
           loadingUtils.startLoading()
           let data = {
              exportType : this.rangevalue,
              startTime: `${this.rangeTime[0] ? this.rangeTime[0]: '' }`,
              endTime:  `${this.rangeTime[1] ? this.rangeTime[1]: '' }`,
            }
            axios.post(`${apiBaseUrl}/teacher/exportTeaType`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "跟进学员.xlsx"; 
                    downloadLink.click();
                    loadingUtils.endLoading()
                    this.$message({ message: "导出成功", type: "success" });
                    this.rangevalue = ''
                    this.rangeTime = []
                    this.addBtnShow = false
                }
                else{
                  this.$message.error("导出失败");
                }
            })
    },
    getPlan () {
      axios
        .get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.planlist = res.data.data
        })
        .catch(error => { });
    },
    // 在弹出添加表单之前从后台获取讲师的编号
    addTeacher () {
      this.addTeacherForm = {
        monStatus: 1,
        satNum: 1,
        sunNum: 1,
      }
      this.$axios
        .get(`${apiBaseUrl}/teacher/no`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            let number = parseInt(res.data.message) + 1;
            // 给讲师编号赋值
            this.addTeacherForm.teacherNo = number.toString();
          }
        })
        .catch(error => { });
      this.visibleAddForm = true;
    },
    addBtn(){
      this.addBtnShow = true
    },
    // 提交添加讲师的表单
    addCommit () {
      // console.log(this.entryTime);
      // console.log(this.radio);
      if (this.addTeacherForm.radio == "1") {
        this.addTeacherForm.recruitmentChannel = "BOSS直聘";
        this.name1 = "";
      } else {
        this.addTeacherForm.recruitmentChannel = "内推";
        this.addTeacherForm.introducerName = this.name1;
        this.addTeacherForm.bossName = ""
      }
      // console.log(this.recruitmentChannel);
      this.addTeacherForm.jobtitle = this.addTeacherForm.jobName;
      // console.log(this.addTeacherForm);

      // this.addTeacherForm.teach = this.addTeacherForm.teach.length > 0 ? JSON.stringify(this.addTeacherForm.teach): ''

      this.addTeacherForm.teach = this.addTeacherForm.teach.length > 0 ? '[' + this.addTeacherForm.teach + ']' : ''

      this.$axios
        .post(`${apiBaseUrl}/teacher/add`, this.addTeacherForm,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res.data,"1");
          if (res.data.code == 200) {
            this.$message({ message: "添加讲师成功", type: "success" });
            this.visibleAddForm = false;
            this.$refs.addTeacherForm.resetFields();
            this.allTeacher();
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          this.$message.error("添加讲师失败");
        });
    },

    // 编辑提交保存讲师信息
    commit () {
      if (this.editFormData.radio1 == "1") {
        this.editFormData.recruitmentChannel = "BOSS直聘";
        this.editFormData.name = "";
      } else {
        this.editFormData.recruitmentChannel = "内推";
        this.editFormData.bossName = ""
      }




      const data = {
        id: this.editFormData.id,
        email: this.editFormData.email,
        teach: this.editFormData.teach.length > 0 ? '[' + this.editFormData.teach + ']' : '',
        realname: this.editFormData.realname,
        telephone: this.editFormData.telephone,
        age: this.editFormData.age,
        jobStatus: this.editFormData.jobStatus,
        jobtitle: this.editFormData.jobName,
        entryTime: this.editFormData.entryTime,
        introducerName: this.editFormData.name,
        recruitmentChannel: this.editFormData.recruitmentChannel,
        graduationSchool: this.editFormData.graduationSchool,
        education: this.editFormData.education,
        cardId: this.editFormData.cardId,
        bossName: this.editFormData.bossName,
        monStatus: this.editFormData.monStatus,
        satNum: this.editFormData.satNum,
        sunNum: this.editFormData.sunNum,
        address: this.editFormData.address,
        salaryPlanId: this.editFormData.salaryPlanId,
        email:this.editFormData.email,
      };

      axios
        .post(`${apiBaseUrl}/teacher/update`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if(res.data.code === 200){
            this.$message({ message: res.data.message, type:'success' })
          }
          this.visibleForm = false;
          
          this.editFormData.bossName = ""
          this.editFormData.name = ""
          this.allTeacher();
        })
        .catch(err => {
          console.log(err);
        });
      let modifyData = this.editFormData;
      // this.modifyTeacher(this.editFormData);
    },

    inputListener () {
      this.allTeacher();
    },

    //分页
    handleSizeChange (pageSize) {
      this.jobParameters.pagesize = pageSize;
      if (this.jobParameters.page === 1) {
        this.allTeacher(this.jobParameters);
      }
    },
    //进入某一页
    handleCurrentChange (newPage) {
      this.jobParameters.currentpage = newPage;
      this.allTeacher();
    },

    deleteById (index, row) {
      this.$confirm('是否继续操作删除教师?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteTeacherById(row.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //点击编辑回显数据
    editById (index, row) {
      if (row.recruitmentChannel == "BOSS直聘") {
        this.editFormData.radio1 = "1";
      } else {
        this.editFormData.radio1 = "2";
      }
      axios
        .get(`${apiBaseUrl}//teacher/${row.id}`, row,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res, "99999999999999");
          if (res.data.code == 200) {
            this.editFormData.email = res.data.data.email;
            this.editFormData.realname = res.data.data.realname;
            this.editFormData.teach = res.data.data.teach ? JSON.parse(res.data.data.teach.replace(/\s/g, "")) : []
            this.editFormData.telephone = res.data.data.telephone;
            this.editFormData.age = res.data.data.age;
            this.editFormData.jobStatus = res.data.data.jobStatus;
            this.editFormData.salaryPlanId = res.data.data.salaryPlanId
            this.editFormData.jobName = res.data.data.jobtitle;
            this.editFormData.id = res.data.data.id;
            this.editFormData.entryTime = res.data.data.entryTime;
            this.editFormData.name = res.data.data.introducerName;
            this.editFormData.graduationSchool = res.data.data.graduationSchool;
            this.editFormData.education = res.data.data.education;
            this.editFormData.cardId = res.data.data.cardId;
            this.editFormData.monStatus = res.data.data.monStatus;
            this.editFormData.satNum = res.data.data.satNum;
            this.editFormData.sunNum = res.data.data.sunNum;
            this.editFormData.address = res.data.data.address;
            this.editFormData.email = res.data.data.email
            this.editFormData.bossName = res.data.data.bossName

            console.log(res.data.data);

            this.visibleForm = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
      let modifyId = row.id;
    },
    /**
     * 根据ID更新讲师
     */
    modifyTeacher (modifyData) {
      // this.$axios
      //   .post(`${apiBaseUrl}/teacher/modify`, modifyData)
      //   .then(res => {
      //     this.$message({ message: "更新成功", type: "success" });
      //     this.allTeacher();
      //     this.visibleForm = false;
      //   })
      //   .catch(error => {
      //     this.$message.error("更新失败");
      //   });
    },

    //关键词搜索讲师
    searchTeacher () {
      this.allTeacher();
      // this.page = 1;
      // this.$axios
      //   .get(`${apiBaseUrl}/teacher/search/` + this.page + "/" + this.keyword)
      //   .then(res => {
      //     console.log(res);
      //     let ret = res.data.data;
      //     this.teacherData = ret.records;
      //     this.total = ret.total;
      //     this.$message({ message: "查询成功", type: "success" });
      //   })
      //   .catch(error => {
      //     this.$message.error("查询失败");
      //   });
    },
    //下拉职级选择
    fetchJob () {
      axios
        .get(`${apiBaseUrl}/teacher/query/job`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res,'111');
          this.jobs = res.data.data.list;
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 根据ID删除讲师
     */
    deleteTeacherById (id) {
      this.$axios
        .delete(`${apiBaseUrl}/teacher/delete/` + id,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.allTeacher();
          this.$message({ message: "删除成功", type: "success" });
        })
        .catch(error => {
          this.$message.error("删除失败");
        });
    },

    // 获取所有讲师，带分页
    allTeacher () {
      axios
        .post(`${apiBaseUrl}/teacher/query`, {
          page: this.jobParameters.currentpage,
          limit: this.jobParameters.pagesize,
          realname: this.keyword
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          console.log(res, "ppppp");
          this.teacherData = res.data.data.list;
          this.total = res.data.data.count;
        })
        .catch(error => {
          this.$message.error("查询讲师列表失败");
        });
    },
    handleUploadSuccess () {
      this.allTeacher();
    },
    highlightRow (index) {
      // 清除之前的高亮状态
      if (this.highlightedIndex !== -1) {
        // 假设表格组件提供了清除高亮的方法，如 clearHighlight
        this.$refs.table.clearHighlight();
      }
      // 设置当前行为高亮状态
      // 假设表格组件提供了设置高亮的方法，如 highlightRow
      this.$refs.table.highlightRow(index);
      this.highlightedIndex = index;
    }
  }
};
</script>

<style scoped>
.addbtn {
  margin-left: 15px;
}

.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

.name-link {
  text-decoration: none;
  /* 这将移除下划线 */
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  .board-container {
    width: 100%;
  }
}

.block {
  width: 200px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 70%;
  }

  #ff>>>.el-dialog {
    width: 70% !important;
  }

  .el-input-group {
    width: 60%;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/TeacherList.vue